/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  const popover_triggers = document.querySelectorAll('button[popovertarget]');

  popover_triggers.forEach((popover_trigger) => {
    popover_trigger.addEventListener('click', () => {
      const rect = popover_trigger.getBoundingClientRect();
      const popover = document.getElementById(popover_trigger.getAttribute('popovertarget'));

      console.log(rect);

      let popover_left = rect.left + (rect.width / 2);

      popover.style.top = `${rect.top}px`;
      popover.style.left = `${popover_left}px`;
    });
  });
}());